import React, { useEffect, useContext } from "react";
import { Card, Input, List, Modal } from "antd";
import "Common/hooks/StyleFeatures/ChatApp.scss";
import Sidebar from "./ChatSidebar";
import ChatWindow from "./ChatWindow";
import useCounselorChat from "./useChat";
import { useLocation } from "react-router-dom";
import useSignalRPresence from "Common/SingleRConnection/useSignalRPresence";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const StartChat = () => {
  const { unreadMessages } = useSignalRPresence();
  const {
    handleFileUpload,
    hubConnection,
    personalId,
    token,
    members,
    groups,
    activeChats,
    isModalVisible,
    loading,
    mentorModelVisible,
    chatMessages,
    chatDetails,
    startChat,
    sendMessage,
    hoveredId,
    setHoveredId,
    search,
    setSearch,
    modelSearch,
    setModelSearch,
    setIsModalVisible,
    setMentorModelVisible,
    setSelectedChatId,
    selectedChatId,
    fetchChatDetails,
    setChatDetails,
    setChatMessages,
    loader,
    conversations,
    msgLoader,
    role,
    startMentorGroupChat,
  } = useCounselorChat();
  const location = useLocation();
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = role !== "Admin" && !isProfileComplete;

  let navigateTo = "";
  if (role == "Mentor") { navigateTo = "/mentor-profile" } else { if (role == "Learner") { navigateTo = "/learner-profile" } }
  useEffect(() => {
    if (location.state?.selectedChatId) {
      setSelectedChatId(location.state.selectedChatId);
    }
  }, [location.state]);

  return (
    <Card
      className="card-professional"
      title="Chat"
      style={{
        pointerEvents: isBlocked ? "none" : "auto",
        opacity: isBlocked ? 0.6 : 1,
        transition: "opacity 0.3s ease",
      }}
    >
      <div className="chat-container">
        <Sidebar
          activeChats={activeChats}
          search={search}
          setSearch={setSearch}
          setIsModalVisible={setIsModalVisible}
          setMentorModelVisible={setMentorModelVisible}
          setSelectedChatId={setSelectedChatId}
          selectedChatId={selectedChatId}
          hoveredId={hoveredId}
          setHoveredId={setHoveredId}
          userId={personalId}
          token={token}
          loader={loader}
          conversations={conversations}
          unreadMessages={unreadMessages}
        />

        <div className="chat-section-wrap">
          {selectedChatId ? (
            <>
              <ChatWindow
                handleFileUpload={handleFileUpload}
                setSelectedChatId={setSelectedChatId}
                hubConnection={hubConnection}
                selectedChatId={selectedChatId}
                sendMessage={sendMessage}
                userId={Number(personalId)}
                token={token}
                fetchChatDetails={fetchChatDetails}
                chatDetails={chatDetails}
                chatMessages={chatMessages || []}
                setChatDetails={setChatDetails}
                setChatMessages={setChatMessages}
                loading={loading}
                msgLoader={msgLoader}
                conversations={conversations}
              />
            </>
          ) : (
            <div className="chat-header2">Click New Chat / Group Chat to start a conversation</div>
          )}
        </div>

        <Modal
          title="Select Member"
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
        >
          <Input
            placeholder="Search..."
            value={modelSearch}
            onChange={(e) => setModelSearch(e.target.value)}
            style={{ marginBottom: "10px" }}
          />

          {(role === "Learner" || role === "Admin" || role === "Mentor") && (
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              <List
                bordered
                dataSource={members.filter((member) =>
                  member.name?.toLowerCase().includes(modelSearch.toLowerCase())
                )}
                renderItem={(member) => (
                  <List.Item
                    onClick={() => {
                      startChat(member);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {member.name}
                  </List.Item>
                )}
              />
            </div>
          )}
        </Modal>

        <Modal
          title="Select Member to create a group"
          open={mentorModelVisible}
          onCancel={() => setMentorModelVisible(false)}
          footer={null}
        >
          <Input
            placeholder="Search..."
            value={modelSearch}
            onChange={(e) => setModelSearch(e.target.value)}
            style={{ marginBottom: "10px" }}
          />
          <div style={{ maxHeight: "300px", overflowY: "auto" }}>
            <List
              bordered
              dataSource={groups.filter((mentorGroup) =>
                mentorGroup.groupName?.toLowerCase().includes(modelSearch.toLowerCase())
              )}
              renderItem={(mentorGroup) => (
                <List.Item
                  onClick={() => {
                    startMentorGroupChat(mentorGroup);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {mentorGroup.groupName}
                </List.Item>
              )}
            />
          </div>
        </Modal>
      </div>
    </Card>
  );
};
export default StartChat;